// CallToActionThree component - Converted from components/CallToActionThree.vue
// Simple call to action section
// Converted: <template> -> JSX, NuxtLink -> Link
import React from 'react';
import { Link } from 'react-router-dom';

const CallToActionThree = () => {
  return (
    <section className="cta_three" style={{ marginTop: '3rem' }}>
      <div className="container">
        <div className="row">
          <div className="col-xl-12">
            <div className="cta_three_content wow fadeInUp" data-wow-delay="300ms">
              <div className="cta_three_text">
                <h2>Nous fournissons des produits 
                de haute qualité</h2>
              </div>
              <div className="cta_three_btn">
                <Link to="/service" className="thm-btn">Découvrez-en plus</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToActionThree;
